"use client";

import { ChevronRightIcon } from "@/components/event-detail/chevron-right-icon";
import EmptyState from "@/components/portfolio/empty-state";
import { navigateToOrderGuessDetail, useAppRouter } from "@/utils/router";
import { get } from "@/utils/utils";
import { type OrderItemLike, OrderPositionCard } from "./OrderPositionCard";

interface OrdersTabProps {
    ordersItems: any[];
    onCancelOrder: ( order: any ) => void;
    onCancelAll: () => void;
    event: any;
    guessNo: string;
    eventNo?: string;
    currentGuess?: any;
}

export function OrdersTab(
    { ordersItems, onCancelOrder, onCancelAll, event, guessNo, eventNo: eventNoProp, currentGuess }: OrdersTabProps,
) {
    const eventNo = eventNoProp ?? get( event, "eventNo", "" );
    const router = useAppRouter();

    return (
        <>
            {ordersItems.length === 0 && (
                <EmptyState text="No open orders" className="h-auto py-4" textClassName="text-[13px]" />
            )}
            {ordersItems.length > 0 && (
                <div className="flex flex-col gap-2 pt-3">
                    <div className="flex items-center justify-between">
                        <span className="text-xs font-[500] text-t3">Order Qty:</span>
                        <button
                            type="button"
                            className="flex items-center text-xs font-[500] text-t1 hover:opacity-80"
                            onClick={() => {
                                if ( guessNo && eventNo ) {
                                    navigateToOrderGuessDetail( router, {
                                        eventNo,
                                        guessGroupNo: get( currentGuess, "guessGroupNo", "" ),
                                        guessNo,
                                    } );
                                }
                            }}
                        >
                            +{ordersItems.length} More
                            <ChevronRightIcon className="h-4 w-4 text-t4" />
                        </button>
                    </div>
                    {ordersItems.slice( 0, 2 ).map( ( order: any, index: number ) => (
                        <OrderPositionCard
                            key={get( order, "orderNo", index )}
                            type="order"
                            item={order as OrderItemLike}
                            currentGuess={currentGuess}
                            guessNo={guessNo}
                            eventNo={eventNo}
                            onCancel={onCancelOrder}
                            isSports={false}
                        />
                    ) )}
                </div>
            )}
        </>
    );
}
